module.exports = __webpack_public_path__ + "static/gallery-9@2x-4d22004663c1c8e00656ef645404973a.jpg";